<ng-container *msShowInEpcot="true">
    <div class="content-message-container betslip-over-ask-stakechange">
        <div class="content-message info">
            <vn-icon class="over-ask-ifo-icon" name="theme-info-i" size="16" />
            <span class="ui-icon betslip-over-ask-stakechange-icon"></span>
            <div class="page-matrix">
                <div class="pc-text pc-component">
                    <span class="betslip-notification-title">{{ messages.maxStakeHeader }}</span>
                    <section class="pc-richtext betslip-over-ask-stakechange-body" [innerHtml]="messages.maxStakeMsg"></section>
                </div>
                <div class="betslip-over-ask-stakechange-body-checkbox">
                    <span class="always-accept-text-epcot">{{ messages.maxStakeToggle }}</span>
                    <ds-switch [checked]="!!settings.stakeChangeConsent" (checkedChange)="save($event)" />
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *msShowInEpcot="false">
    <div class="betslip-over-ask-stakechange-nonepcot">
        <div class="betslip-over-ask-stakechange-nonepcot-banner">
            <span class="ui-icon ui-icon-size-xl">
                <vn-icon name="theme-betslip" size="24" />
            </span>
            <div class="betslip-over-ask-stakechange-nonepcot-banner-content">
                <span class="stakechange-content-header">{{ messages.maxStakeHeader }}</span>
                <span class="stakechange-content-body">{{ messages.maxStakeMsg }}</span>
                <div class="switcher-lg stakechange-content-checkbox">
                    <label class="always-accept-text">{{ messages.maxStakeToggle }}</label>
                    <ds-switch
                        msThemedSwitch
                        [themedVariant]="variant"
                        [themeInverse]="themeInverseIndicator"
                        [checked]="!!settings.stakeChangeConsent"
                        (checkedChange)="save($event)" />
                </div>
            </div>
        </div>
    </div>
</ng-container>
